module.exports = "/images/blister-10.png";